import React from "react";
import { Column, Row } from "@components/Flex";
import SizedBox from "@components/SizedBox";
import Text from "@components/Text";
import { observer } from "mobx-react-lite";
import BN from "@src/utils/BN";
import SquareTokenIcon from "@components/SquareTokenIcon";
import styled from "@emotion/styled";

interface IProps {
  availableAmount?: BN | null;
  depositAmount: BN;
  share: BN;
  name: string;
  logo: string;
}

const Root = styled.div<{ warning: boolean }>`
  .text {
    color: ${({ theme, warning }) => warning && theme.colors.error500};
  }
`;

const ShareText = styled.span<{ isLowMoney: boolean }>`
  color: ${({ theme, isLowMoney }) => (isLowMoney ? theme.colors.error500 : theme.colors.primary800)};
`;

const DepositCompositionRow: React.FC<IProps> = ({ availableAmount, depositAmount, share, name, logo }) => {
  const available = availableAmount ? availableAmount.toSmallFormat() : "-";
  const deposit = depositAmount.toSmallFormat();
  const isLowMoney = availableAmount != null && availableAmount.eq(0);
  return (
    <Root className="gridRow" warning={isLowMoney}>
      <Row alignItems="center" mainAxisSize="fit-content">
        <SquareTokenIcon size="small" src={logo} alt="logo" />
        <SizedBox width={8} />
        <Column>
          <Text fitContent size="medium" className="text">
            {name}
          </Text>
          <Text fitContent type="secondary" size="small" className="text">
            <span>Share: </span>
            <ShareText isLowMoney={isLowMoney}>
              {share.toFormat(2)} %
            </ShareText>
          </Text>
        </Column>
      </Row>
      <Column style={{ width: "100%", textAlign: "end" }}>
        <Text nowrap className="text">
          {deposit}
        </Text>
        <Text type="secondary" size="small" className="text">
          Available: {available}
        </Text>
      </Column>
    </Root>
  );
};
export default observer(DepositCompositionRow);
